export const HOME_PATHNAME                 = '/';
export const LOGIN_PATHNAME                = '/login/';
export const LOGIN_PARAM_PATHNAME          = (_: unknown, result: string, email?: string) => `${ LOGIN_PATHNAME }?result=${ result }${ email
    ? `&email=${ email }`
    : '' }`;
export const VERIFY_EMAIL_EARLIER          = 'verify-email-earlier';
export const VERIFY_EMAIL_SUCCESS          = 'verify-email-success';
export const VERIFY_EMAIL_FAIL             = 'verify-email-fail';
export const NOT_FOUND                     = 'not-found';
export const PASSWORD_RESET                = 'password-reset';
export const PASSWORD_RESET_PATHNAME       = `/login/?result=${ PASSWORD_RESET }`;
export const VERIFY_EMAIL_PATHNAME         = '/verify-email/';
export const FORGOT_PATHNAME               = '/forgot/';
export const FORGOT_SENT_PATHNAME          = '/forgot/sent/';
export const FORGOT_RESET_PATHNAME         = '/forgot/reset/';
export const REGISTRATION_PATHNAME         = '/registration/';
export const ONBOARDING_PATHNAME           = '/onboarding/';
export const PENDING_CHECKOUT_PATHNAME     = '/pending-checkout/';
export const REGISTRATION_SUCCESS_PATHNAME = '/registration/success/';
export const REGISTRATION_INVITE_PATHNAME  = (token: string, email?: string | null) => {
    const search = email ? `?${ new URLSearchParams({ email }).toString() }` : '';

    return `${ REGISTRATION_PATHNAME }invite/${ encodeURIComponent(token) }/${ search }`;
};
export const TERMS_PATHNAME                = '/docs/CarrierCheck_BV__Terms_of_Service__v1-5.pdf';
export const DATA_PROCESSING_PATHNAME      = '/docs/CarrierCheck_BV__Data_Processing_Agreement__v1-5.pdf';
export const IMPRINT_PATHNAME              = '/docs/CarrierCheck_BV__Privacy_Policy__v1-5.pdf';
export const COOKIES_POLICY_PATHNAME       = '/docs/CarrierCheck_BV__Cookies_Policy__v1-5.pdf';
export const ACCOUNT_PATHNAME              = '/account/';
export const TEAM_PATHNAME                 = '/team/';
export const TEAM_UPGRADE_PATHNAME         = '/team/upgrade/';
export const TEAM_INVITES_PATHNAME         = '/team/?tab=invites';
export const ACCOUNT_NOTIFICATION_PATHNAME = '/account/#notification_settings';
export const SUBSCRIPTION_PATHNAME         = '/subscription/';
export const BILLING_PATHNAME              = '/billing/';
export const SUPPORT_PATHNAME              = '/support/';
export const VERIFICATION_PATHNAME         = '/verification/';
export const PDF_REPORTS_PATHNAME          = (_: unknown, id: number) => `/pdf/reports/${ id }`;
export const PRINT_REPORTS_PATHNAME        = (_: unknown, id: number) => `/print/reports/${ id }`;
export const HISTORY_PATHNAME              = '/history/';
export const REPORT_PATHNAME               = '/report/';
export const REPORT_AS_INCIDENT_PATHNAME   = (_: unknown, companyName?: string, email?: string, vatNumber?: string) => {
    const params = new URLSearchParams();

    if (companyName) params.set('companyName', companyName);
    if (email) params.set('email', email);
    if (vatNumber) params.set('vatNumber', vatNumber);

    const searchQuery = params.toString();
    const search      = searchQuery ? '?' + searchQuery : '';

    return `${ REPORT_PATHNAME }${ search }`;
};

export const PUBLIC_PATHNAMES = new Set([
    HOME_PATHNAME,
    LOGIN_PATHNAME,
    VERIFY_EMAIL_PATHNAME,
    FORGOT_PATHNAME,
    FORGOT_SENT_PATHNAME,
    FORGOT_RESET_PATHNAME,
    REGISTRATION_PATHNAME,
    REGISTRATION_SUCCESS_PATHNAME,
    TERMS_PATHNAME,
    IMPRINT_PATHNAME,
    COOKIES_POLICY_PATHNAME,
    DATA_PROCESSING_PATHNAME,
]);

export const AUTH_PATHNAMES = new Set([
    LOGIN_PATHNAME,
    FORGOT_PATHNAME,
    REGISTRATION_PATHNAME,
]);
